<div class="section-container"> 
    <div>
        Discover the 10 trends that will define the future of aesthetics…
        <app-navigate-button direction="down" [sectionId]="nextSectionId"></app-navigate-button>

    </div>
</div>